import React from 'react';
import { Stack, Title, Text, Button, Group, Card, Divider, Paper, Alert, Badge, List, Loader } from '@mantine/core';
import { highlightVariables } from '../../utils/messageUtils';
import { useCampaign } from '../../context/CampaignContext';
import { useClient } from '../../context/ClientContext';
import { useSalon } from '../../context/SalonContext';
import moment from 'moment-timezone';

function FinalReviewStep({ date, onBack, onSubmit }) {
  const {
    name,
    description,
    message,
    complianceWarnings: warnings,
    selectedClientIds,
    campaignCreationLoading,
    isScheduled,
    scheduledDate,
    scheduledTime
  } = useCampaign();
  
  const { businessInfo } = useSalon();
  const { clients } = useClient();
  const selectedClients = clients.filter(c => selectedClientIds.includes(c.id));
  const recipientCount = selectedClients.length;
  const showNames = selectedClients.slice(0, 4);
  const moreCount = recipientCount > 4 ? recipientCount - 4 : 0;

  const formattedScheduledTime = isScheduled 
    ? moment.tz(scheduledDate, businessInfo.timezone)
        .hour(moment(scheduledTime, 'h:mm A').hour())
        .minute(moment(scheduledTime, 'h:mm A').minute())
        .format('MMM D, YYYY h:mm A')
    : null;

  return (
    <Stack gap="md">
      <Title order={3}>Final Review</Title>
      <Card withBorder radius="md" shadow="xs" p="md">
        <Stack gap="xs">
          <Group>
            <Text fw={600}>Date:</Text>
            <Text>{isScheduled ? formattedScheduledTime : date}</Text>
          </Group>
          <Group>
            <Text fw={600}>Campaign Name:</Text>
            <Text>{name}</Text>
          </Group>
          <Group>
            <Text fw={600}>Description:</Text>
            <Text>{description}</Text>
          </Group>
          <Divider my="sm" />
          <Text fw={600} mb={2}>Recipients ({recipientCount} total):</Text>
          <List size="sm" spacing={2}>
            {showNames.map((c, i) => (
              <List.Item key={c.id || i}>{c.first_name} {c.last_name}</List.Item>
            ))}
            {moreCount > 0 && (
              <List.Item key="more">and {moreCount} more</List.Item>
            )}
          </List>
          <Divider my="sm" />
          <Text fw={600} mb={2}>Your Message Template:</Text>
          <Paper withBorder p="sm" radius="md">
            <Text size="sm" style={{ fontFamily: 'monospace', whiteSpace: 'pre-line' }}>
              {highlightVariables(message)}
            </Text>
          </Paper>
          {warnings && warnings.length > 0 && (
            <Alert color="yellow" title="Warnings" mt="md">
              {warnings.map((w, i) => (
                <Text key={i} color="yellow" size="sm">{w}</Text>
              ))}
            </Alert>
          )}
        </Stack>
      </Card>
      <Group justify="space-between" mt="md">
        <Button variant="default" onClick={onBack}>&larr; Back</Button>
        <Button 
          color="violet" 
          onClick={onSubmit} 
          loading={campaignCreationLoading}
          disabled={campaignCreationLoading}
        >
          {campaignCreationLoading ? 'Creating Campaign...' : 'Create Campaign'}
        </Button>
      </Group>
    </Stack>
  );
}

export default FinalReviewStep; 